import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { Tractor, Wrench, Fuel, AlertCircle, Clock, Zap } from 'lucide-react';

export function EquipmentKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng số thiết bị',
      value: 124,
      suffix: 'Máy',
      icon: Tractor,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Đang hoạt động',
      chartColor: 'bg-blue-500',
      chartData: [120, 122, 122, 123, 124, 124, 124]
    },
    {
      title: 'Đang bảo dưỡng',
      value: 8,
      suffix: 'Máy',
      icon: Wrench,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'neutral',
      trendValue: 'Theo kế hoạch',
      chartColor: 'bg-amber-500',
      chartData: [5, 6, 8, 7, 8, 8, 8]
    },
    {
      title: 'Cảnh báo sự cố',
      value: 2,
      suffix: 'Máy',
      icon: AlertCircle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'up',
      trendValue: 'Cần sửa gấp',
      chartColor: 'bg-red-500',
      chartData: [1, 0, 1, 2, 1, 2, 2]
    },
    {
      title: 'Tiêu thụ nhiên liệu',
      value: '2.4',
      suffix: 'k Lít',
      icon: Fuel,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [2.1, 2.2, 2.3, 2.3, 2.4, 2.4, 2.4]
    },
    {
      title: 'Giờ vận hành',
      value: '14.5',
      suffix: 'k Giờ',
      icon: Clock,
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      trend: 'up',
      trendValue: 'Lũy kế',
      chartColor: 'bg-teal-500',
      chartData: [13, 13.5, 13.8, 14.1, 14.3, 14.5, 14.5]
    },
    {
      title: 'Hiệu suất khai thác',
      value: 88,
      suffix: '%',
      icon: Zap,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Tối ưu',
      chartColor: 'bg-emerald-500',
      chartData: [85, 86, 85, 87, 88, 88, 88]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
